import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { SubscribeComponent } from './subscribe.component';
import { SubscriptionPlanCardComponent } from './subscription-plan-card.component';
import { SubscriptionFeaturesTableComponent } from './subscription-features-table.component';
import { EnumSelectPipeModule } from '../../components/pipes/enumselectpipe/enumSelectPipe.module'
import { AuthModule } from '../../auth/auth.module';
import { TermsAndConditionsModalModule } from '../../components/common/terms.and.conditions.modal/t.and.c.modal.module';
import { CardPaymentModule } from '../../components/common/card.payment/card.payment.module';
import { BlockUIModule } from 'ng-block-ui';
import { PaymentProcessingComponent } from './payment.processing.component';
import { SafeHtmlPipeModule } from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';
import { ImgSrcPrefixPipeModule } from '../../components/pipes/imgsrcprefix.pipe/img.src.pipe.module';
import { PhoneComponent } from './phone.component';
import { BacsComponent } from './bacs.component';
import { CardComponent } from './card.component';

@NgModule({
    declarations: [
        SubscribeComponent,
        SubscriptionPlanCardComponent,
        SubscriptionFeaturesTableComponent,
        PaymentProcessingComponent,
        PhoneComponent,
        BacsComponent,
        CardComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        PagingModule,
        RouterModule,
        TooltipModule,
        EnumSelectPipeModule,
        AuthModule,
        TermsAndConditionsModalModule,
        CardPaymentModule,
        BlockUIModule,
        SafeHtmlPipeModule,
        ImgSrcPrefixPipeModule
    ]
})

export class SubscriptionModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/subscription.module.ts